import styled from 'styled-components';

import { BG_GRAY, NAVIGATION_MOBILE_HEIGHT, WHITE } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Chevron = styled.span`
  border-style: solid;
  border-width: 0.15em 0.15em 0 0;
  border-color: ${WHITE};
  content: '';
  display: inline-block;
  height: 0.7em;
  transform: rotate(${({ expanded }) => (expanded ? '-45' : '135')}deg);
  vertical-align: top;
  width: 0.7em;
  margin-left: 0.7em;
  margin-top: 2px;
`;

export const ExpandButton = styled.button`
  float: right;
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: right;
  outline: none;
`;

export const ExpandButtonWrapper = styled.div`
  flex: 2;
`;

export const ExpandedWrapper = styled.div`
  position: absolute;
  top: ${NAVIGATION_MOBILE_HEIGHT}px;
  left: 0;
  right: 0;
  display: ${({ expanded }) => (expanded ? 'flex' : 'none')};
  background: ${BG_GRAY.COMMON_8};
  padding: 10px 20px 20px;
`;

export const Logo = styled.img`
  width: 70%;
  height: auto;
`;

export const LogoutButton = styled.p`
  color: ${WHITE};
  margin-bottom: 0;
  text-transform: uppercase;
  text-decoration: underline;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0.2px;
  background: transparent;
  padding: 0;
  cursor: pointer;
  border: none;
  display: block;
  margin-top: 1em;
`;

export const LogoutButtonPlaceholder = styled.div`
  margin-top: 1em;
`;

export const LogoSection = styled.div`
  display: flex;
  height: calc(${NAVIGATION_MOBILE_HEIGHT}px - 40px); /* deducting the padding of the wrapper */
  align-items: center;
`;

export const LogoWrapper = styled.div`
  flex: 1;
  max-width: 140px;
`;

export const MainSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SwitchButton = styled.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
  margin: 0;
  padding: 0;
  width: 40px;
  height: 40px;
`;

export const SwitchSection = styled.div`
  margin-left: auto;
  border-left: 1px solid ${WHITE};
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 15px;
  width: 62px;
  height: 48px;
`;

export const UserLocation = styled.span`
  color: ${WHITE};
  font-size: 10px;
  letter-spacing: 0.2px;
`;

export const UserName = styled.span`
  color: ${WHITE};
  font-size: 10px;
  letter-spacing: 0.2px;
  border-right: 1px solid ${WHITE};
  padding-right: 10px;
  margin-right: 10px;
`;

export const Wrapper = styled.div`
  background: ${BG_GRAY.COMMON_8};
  height: fit-content;
  padding: 20px;
  align-items: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;

  ${media.tabletP`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/StylistHeader/MobileHeader/MobileHeader.style.js